import { Element, html } from '@guiseek/web-core'

declare global {
  interface HTMLElementTagNameMap {
    'seek-twitter-icon': TwitterIconElement
  }
}

@Element({
  selector: 'seek-twitter-icon',
  template: html`
    <svg
      width="100"
      height="100"
      viewBox="0 0 172 172"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M154.787 43.2311C154.018 42.3147 152.739 42.0217 151.642 42.5028C149.992 43.2311 148.296 43.8788 146.56 44.4351C148.775 41.6536 150.489 38.4796 151.597 35.0531C151.938 33.9888 151.591 32.8305 150.72 32.1318C149.85 31.4303 148.64 31.3389 147.681 31.9087C142.905 34.7064 137.812 36.7139 132.521 37.883C126.968 32.5779 119.457 29.5625 111.679 29.5625C95.0999 29.5625 81.6086 42.9409 81.6086 59.3857C81.6086 60.4714 81.6677 61.5626 81.7887 62.6483C61.8743 60.7536 43.387 50.9765 30.6536 35.4965C30.0973 34.8193 29.2615 34.4618 28.3692 34.5236C27.4958 34.5908 26.7084 35.0799 26.2622 35.8351C23.5936 40.3474 22.1799 45.5451 22.1799 50.8663C22.1799 57.4426 24.3487 63.7126 28.2187 68.8188C27.434 68.4883 26.6627 68.1201 25.9102 67.7116C25.0744 67.2627 24.0666 67.2789 23.2549 67.768C22.4406 68.2544 21.9434 69.1306 21.9434 70.0766V70.3964C21.9434 80.3616 26.9637 89.4051 34.8058 94.8634C34.7736 94.858 34.7413 94.8499 34.7091 94.8446C33.7684 94.6699 32.8305 95.0112 32.2097 95.7234C31.5889 96.4356 31.3873 97.4192 31.6776 98.3195C34.8542 108.123 42.828 115.442 52.5567 118.024C44.4862 122.784 35.3541 125.272 25.7973 125.272C23.6849 125.272 21.5967 125.149 19.5946 124.904C18.3395 124.746 17.1597 125.49 16.7377 126.67C16.3158 127.852 16.77 129.172 17.8316 129.844C30.8471 138.084 45.8595 142.438 61.2481 142.438C111.698 142.438 141.844 101.805 141.844 62.522C141.844 61.7937 141.83 61.0681 141.806 60.3451C146.931 56.5208 151.352 51.8553 154.964 46.4534C155.628 45.4591 155.555 44.1476 154.787 43.2311ZM137.511 56.8218C136.762 57.3512 136.334 58.2274 136.377 59.1465C136.431 60.2618 136.469 61.3879 136.469 62.522C136.469 99.1607 108.333 137.062 61.2481 137.062C50.5465 137.062 40.033 134.805 30.3446 130.473C41.7019 129.61 52.3767 125.501 61.4524 118.465C62.3527 117.766 62.7155 116.578 62.3554 115.498C61.9952 114.418 60.9955 113.679 59.856 113.654C50.7696 113.48 42.6452 108.408 38.4957 100.66C41.4923 100.762 44.4163 100.394 47.3 99.6041C48.5013 99.2736 49.3183 98.1609 49.2753 96.9166C49.2296 95.6696 48.3347 94.6215 47.1146 94.3769C36.9746 92.3559 29.2911 84.237 27.6463 74.3577C30.6617 75.4408 33.8195 76.0536 36.9666 76.1503C38.2001 76.1799 39.2456 75.422 39.6084 74.2798C39.9739 73.1349 39.5358 71.8879 38.5361 71.2241C31.6614 66.6608 27.5603 59.0498 27.5603 50.8663C27.5603 47.816 28.1247 44.8194 29.2104 42.0325C43.5052 57.6926 63.5674 67.1902 84.8793 68.2625C85.7608 68.3216 86.5375 67.9507 87.075 67.3031C87.6179 66.6554 87.8221 65.79 87.6313 64.9703C87.2013 63.1294 86.9863 61.2508 86.9863 59.3884C86.9863 45.9079 98.0642 34.9402 111.682 34.9402C118.5 34.9402 125.063 37.754 129.688 42.656C130.32 43.3225 131.249 43.6208 132.152 43.4515C135.875 42.7339 139.514 41.6482 143.031 40.2023C141.072 42.9086 138.557 45.2145 135.617 46.9587C134.523 47.6091 134.034 48.934 134.445 50.1407C134.856 51.342 136.049 52.1026 137.315 51.9386C139.874 51.6242 142.384 51.1539 144.832 50.5277C142.599 52.8524 140.153 54.9567 137.511 56.8218Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M82.6997 123.05L84.3686 128.156C103.512 121.905 118.833 106.887 126.407 86.9568L121.384 85.046C117.272 95.8658 106.782 115.184 82.6997 123.05Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M112.875 59.125C115.844 59.125 118.25 56.7185 118.25 53.75C118.25 50.7815 115.844 48.375 112.875 48.375C109.906 48.375 107.5 50.7815 107.5 53.75C107.5 56.7185 109.906 59.125 112.875 59.125Z"
        fill="url(#paint2_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="86"
          y1="26.703"
          x2="86"
          y2="140.274"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1A6DFF" />
          <stop offset="1" stop-color="#C822FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="104.552"
          y1="26.703"
          x2="104.552"
          y2="140.274"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1A6DFF" />
          <stop offset="1" stop-color="#C822FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="112.875"
          y1="48.3186"
          x2="112.875"
          y2="57.8565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6DC7FF" />
          <stop offset="1" stop-color="#E6ABFF" />
        </linearGradient>
      </defs>
    </svg>
  `,
})
export class TwitterIconElement extends HTMLElement {}
